import { render, staticRenderFns } from "./color_setting.vue?vue&type=template&id=26008068&"
import script from "./color_setting.vue?vue&type=script&lang=js&"
export * from "./color_setting.vue?vue&type=script&lang=js&"
import style0 from "./color_setting.vue?vue&type=style&index=0&id=26008068&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports